import { createApp } from 'vue'
import { createPinia } from 'pinia';
import { createHead } from "@vueuse/head";

import App from './App.vue'
import router from './router'

import 'bootstrap-icons/font/bootstrap-icons.css';
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css';
import ContextMenu from '@imengyu/vue3-context-menu';

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import {
        faFilePdf,
        faFileImage,
        faFileExcel,
        faFilePowerpoint,
        faFileWord,
        faFileVideo,
        faFileArchive,
        faFileAlt,
        faFile,
        faFolder,
        faTrashAlt,
        faUpload,
        faTasks,
        faChevronRight,
        faRotate,
        faFolderPlus,
        faDownload,
        faCloudArrowUp,
        faTrashCan,
        faCheck,
        faXmark,
        faCircleExclamation,
        faEye,
        faMagnifyingGlass,
        faSpinner,
        faArrowUpFromBracket,
        faCheckCircle,
        faCircleXmark,
        faTriangleExclamation
       } from '@fortawesome/free-solid-svg-icons';
import { faCircle as faCircleRegular } from '@fortawesome/free-regular-svg-icons';

library.add(
            faFilePdf,
            faFileImage,
            faFileExcel,
            faFilePowerpoint,
            faFileWord,
            faFileVideo,
            faFileArchive,
            faFileAlt,
            faFile,
            faFolder,
            faTrashAlt,
            faUpload,
            faTasks,
            faChevronRight,
            faRotate,
            faFolderPlus,
            faDownload,
            faCloudArrowUp,
            faTrashCan,
            faCheck,
            faXmark,
            faCircleExclamation,
            faEye,
            faMagnifyingGlass,
            faSpinner,
            faArrowUpFromBracket,
            faCheckCircle,
            faCircleXmark,
            faTriangleExclamation,
            faCircleRegular
          );


import '@/assets/base.scss';
import "bootstrap";



const app = createApp(App);
const head = createHead()


app.use(createPinia());
app.use(head);
app.use(router);

app.use(ContextMenu);
app.provide('$contextmenu', ContextMenu.showContextMenu); 

app.component('font-awesome-icon', FontAwesomeIcon);

app.mount('#app');
